import './styles.scoped.css';
export default {
  "arrow": "awsui_arrow_xjuzf_fgu09_185",
  "arrow-outer": "awsui_arrow-outer_xjuzf_fgu09_189",
  "arrow-inner": "awsui_arrow-inner_xjuzf_fgu09_189",
  "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_fgu09_220",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_fgu09_220",
  "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_fgu09_223",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_fgu09_223",
  "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_fgu09_226",
  "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_fgu09_226",
  "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_fgu09_226",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_fgu09_226",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_fgu09_229",
  "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_fgu09_229",
  "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_fgu09_229",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_fgu09_229",
  "body": "awsui_body_xjuzf_fgu09_325",
  "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_fgu09_339",
  "has-dismiss": "awsui_has-dismiss_xjuzf_fgu09_343",
  "dismiss": "awsui_dismiss_xjuzf_fgu09_348",
  "dismiss-control": "awsui_dismiss-control_xjuzf_fgu09_355",
  "header-row": "awsui_header-row_xjuzf_fgu09_359",
  "header": "awsui_header_xjuzf_fgu09_359",
  "content": "awsui_content_xjuzf_fgu09_381",
  "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_fgu09_388",
  "container": "awsui_container_xjuzf_fgu09_484",
  "container-body": "awsui_container-body_xjuzf_fgu09_492",
  "container-body-variant-annotation": "awsui_container-body-variant-annotation_xjuzf_fgu09_507",
  "container-body-size-small": "awsui_container-body-size-small_xjuzf_fgu09_512",
  "fixed-width": "awsui_fixed-width_xjuzf_fgu09_515",
  "container-body-size-medium": "awsui_container-body-size-medium_xjuzf_fgu09_519",
  "container-body-size-large": "awsui_container-body-size-large_xjuzf_fgu09_526",
  "container-arrow": "awsui_container-arrow_xjuzf_fgu09_538",
  "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_fgu09_542",
  "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_fgu09_542",
  "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_fgu09_554",
  "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_fgu09_554",
  "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_fgu09_566",
  "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_fgu09_566",
  "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_fgu09_566",
  "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_fgu09_566",
  "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_fgu09_582",
  "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_fgu09_586",
  "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_fgu09_590",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_fgu09_1",
  "refresh": "awsui_refresh_xjuzf_fgu09_708",
  "root": "awsui_root_xjuzf_fgu09_730",
  "trigger": "awsui_trigger_xjuzf_fgu09_743",
  "trigger-type-text": "awsui_trigger-type-text_xjuzf_fgu09_750",
  "trigger-inner-text": "awsui_trigger-inner-text_xjuzf_fgu09_779",
  "popover-content": "awsui_popover-content_xjuzf_fgu09_783"
};